import React from 'react';

import styled from '@emotion/styled';

import PrimaryButton from '../../components/Button/PrimaryButton';
import { FullTextLogo } from '../../components/CompanyLogo';
import CloseIcon from '../../components/Icons/CloseIcon';
import { ExternalLink, NavLink } from '../../components/Link/Link';
import { NavData } from '../NavData';

interface IHamburgerMenu {
  open: boolean;
  toggleNav: (...arg: any) => void;
}

const HamburgerMenu: React.FC<IHamburgerMenu> = ({ open, toggleNav }) => {
  const handleNavMenuItemClick = (event: any) => {
    toggleNav();
  };
  return (
    <Container className={open ? '' : 'close'}>
      <StyledNav className={open ? '' : 'close'}>
        <LogoAndCloseBtnArea>
          <FullTextLogo className="header" />
          <CloseIconContainer
            className={open ? 'open' : ''}
            onClick={toggleNav}
          >
            <CloseIcon />
          </CloseIconContainer>
        </LogoAndCloseBtnArea>

        <NavElementContainer>
          {NavData.map((item, index) => (
            <NavLink
              key={index}
              to={item.link}
              onClick={handleNavMenuItemClick}
              className="hamburger-menu"
            >
              {item.title}
            </NavLink>
          ))}
          <ExternalLink to="https://darum.ng/contact-us">
            <PrimaryButton>Contact Us</PrimaryButton>
          </ExternalLink>
        </NavElementContainer>
      </StyledNav>
    </Container>
  );
};

export default HamburgerMenu;

const Container = styled.div`
  display: None;
  height: 100vh;
  position: fixed;

  @media screen and (max-width: 480px) {
    width: 100vw;
    display: flex;
    margin-left: auto;
    z-index: 200000000;

    &.close {
      border: 2px solid yellow;
      display: none;
    }
  }
`;

const StyledNav = styled.nav`
  display: flex;
  flex-direction: column;
  width: 20rem;
  margin-left: auto;
  gap: 2rem;

  padding: 2rem;
  padding-top: 1rem;
  background: white;
  overflow-x: auto;
  height: 100%;

  &.close {
    display: none;
  }
`;

const LogoAndCloseBtnArea = styled.div`
  display: flex;
  /* border: 2px solid red; */
  justify-content: space-between;
`;

const CloseIconContainer = styled.div`
  /* border: 2px solid red; */
`;

const NavElementContainer = styled.div`
  /* border: 2px solid red; */
  display: flex;
  gap: 2rem;
  flex-direction: column;
`;
